// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import VueQuill from "vue-quill-editor"
import VueMoment from "vue-moment"
import VueCharts from "vue-chartjs"

Vue.use(VueMoment)
Vue.use(VueQuill)
Vue.use(VueCharts)

import * as filters from './filters'

// register global utility filters.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

import AppHeader from "./views/Header.vue"
Vue.component('app-header', AppHeader)

import Loader from "./components/Loader.vue"
Vue.component('loader', Loader)

import DataTable from "./components/DataTable.vue"
import FormControl from "./components/misc/FormControl.vue"
import FormGroup from "./components/misc/FormGroup.vue"
import SliderControl from "./components/misc/SliderControl.vue"
import ImageControl from "./components/misc/ImageControl.vue"
import ImageableControl from "./components/misc/ImageableControl.vue"
import ImageCropper from "./components/misc/ImageCropper.vue"
import ProductMonthSelector from "./components/misc/ProductMonthSelector.vue"

Vue.component('data-table', DataTable)
Vue.component('form-control', FormControl)
Vue.component('form-group', FormGroup)
Vue.component('slider-control', SliderControl)
Vue.component('image-control', ImageControl)
Vue.component('imageable-control', ImageableControl)
Vue.component('image-cropper', ImageCropper)
Vue.component('product-month-selector', ProductMonthSelector)

import Order from "./components/Order.vue"
import OrderList from "./components/OrderList.vue"
import PrintDialog from "./components/PrintDialog.vue"
import ProductBundles from "./components/products/ProductBundles.vue"
import ProductCategories from "./components/products/ProductCategories.vue"
import ProductTags from "./components/products/ProductTags.vue"
import ProductItems from "./components/products/ProductItems.vue"
import ProductParts from "./components/products/ProductParts.vue"
import BundleProducts from "./components/products/BundleProducts.vue"

Vue.component('order', Order)
Vue.component('order-list', OrderList)
Vue.component('print-dialog', PrintDialog)
Vue.component('product-bundles', ProductBundles)
Vue.component('product-categories', ProductCategories)
Vue.component('product-tags', ProductTags)
Vue.component('product-items', ProductItems)
Vue.component('product-parts', ProductParts)
Vue.component('bundle-products', BundleProducts)


import RecipientFormPart from "./components/orders/RecipientFormPart.vue"

Vue.component('recipient-form-part', RecipientFormPart)

import PageContent from "./components/PageContent.vue"
import ProductPart from "./components/ProductPart.vue"

Vue.component('page-content', PageContent)
Vue.component('product-part', ProductPart)

import ProductForm from "./components/forms/ProductForm.vue"
import BundleForm from "./components/forms/BundleForm.vue"
import ItemForm from "./components/forms/ItemForm.vue"
import TagForm from "./components/forms/TagForm.vue"
import CategoryForm from "./components/forms/CategoryForm.vue"
import DiscountForm from "./components/forms/DiscountForm.vue"
import ImageForm from "./components/forms/ImageForm.vue"
import UserForm from "./components/forms/UserForm.vue"
import UserRecipientForm from "./components/forms/UserRecipientForm.vue"
import AdminForm from "./components/forms/AdminForm.vue"

Vue.component('product-form', ProductForm)
Vue.component('bundle-form', BundleForm)
Vue.component('item-form', ItemForm)
Vue.component('tag-form', TagForm)
Vue.component('category-form', CategoryForm)
Vue.component('discount-form', DiscountForm)
Vue.component('image-form', ImageForm)
Vue.component('user-form', UserForm)
Vue.component('user-recipient-form', UserRecipientForm)
Vue.component('admin-form', AdminForm)

import OrderChart from "./components/charts/orderChart.js"
import OrderPaymentChart from "./components/charts/orderPaymentChart.js"
Vue.component('order-chart', OrderChart)
Vue.component('order-payment-chart', OrderPaymentChart)

import orderLoader from "./components/orders/orderLoader.vue"
Vue.component('order-loader', orderLoader)

import reportSettings from "./components/reports/ReportSettings.vue"
Vue.component('report-settings', reportSettings)

// create the event hub instance
const eventHub = new Vue();

// add $bus to vue prototype to allow child components to access the bus via this.$bus
if (typeof Vue.$bus === 'undefined') {
    Object.defineProperty(Vue.prototype, "$bus", {
        value: eventHub,
        enumerable: true,
        configurable: true
    })
}

Vue.config.productionTip = false

/* eslint-disable no-new */
let app = new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
})



//////////////////
// WEBPACK FOOTER
// ./vue/src/main.js
// module id = 600
// module chunks = 0